import { configuracionDB } from './index'

export async function obtenerConfig() {
  try {
    return await configuracionDB.get('config')
  } catch (e) {
    return { _id: 'config', nombreTienda: 'Mi Tienda', fiadoHabilitado: false }
  }
}

export async function guardarConfig(datos) {
  try {
    const existente = await configuracionDB.get('config')
    return configuracionDB.put({ ...existente, ...datos })
  } catch (e) {
    return configuracionDB.put({ _id: 'config', ...datos })
  }
}
